export const guidRegExPattern = /^[\w\d]{8}-[\w\d]{4}-[\w\d]{4}-[\w\d]{4}-[\w\d]{12}$/i;
export const intRegExPattern = /^[-+]?\d+$/;
export const moneyRegExPattern = /^[-+]?\d+(\.\d{1,2})?$/;
export const urlRegExPattern =
  // eslint-disable-next-line no-useless-escape
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
export enum KEY_CODE {
  ENTER = 13,
  ESCAPE = 27,
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37
}
export const usDateRegExPattern =
  /^02\/(?:[01]\d|2\d)\/(?:19|20)(?:0[048]|[13579][26]|[2468][048])|(?:0[13578]|10|12)\/(?:[0-2]\d|3[01])\/(?:19|20)\d{2}|(?:0[469]|11)\/(?:[0-2]\d|30)\/(?:19|20)\d{2}|02\/(?:[0-1]\d|2[0-8])\/(?:19|20)\d{2}$/;
export const nonWhiteSpace = /^$|\s+/i;
export const singleValue = /^[^\s,]*$/i;
//export const emailPattern = /^([a-zA-Z0-9_\-.+]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})\s?$/;
export const emailPattern = /^\s?([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\s?$/;
export const naPhoneNumber = /^\+?1?[-.\s]?\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})/; //no termination because of extensions
export const invalidFormNameChar = /[*\\/.]/g;
